<template>
	<div class="partner-container">
		<div class="row">
			<div class="col-lg-4">
				<form class="m-form m-form--fit m-form--label-align-right">
					<div class="form-group m-form__group">
						<label for="player-name">Tên tài khoản</label>
						<div class="input-group">
							<input v-model="code" type="text" class="form-control m-input m-input--air" placeholder="Search for...">
							<div class="input-group-append">
								<button @click="fetchDetailSale" class="btn btn-secondary" type="button">Tìm kiếm</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="row m--margin-top-10">
			<div class="col-lg-12">
				<table class="table table-striped m-table">
					<thead>
						<tr>
							<th>#</th>
							<th>Ngày tạo</th>
							<th>Số tháng</th>
							<th>Khuyến mại</th>
							<th>Ngày hết hạn</th>
							<th>Thanh toán</th>
							<th>Hành động</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="detail.length == 0">
							<td colspan="7">Không có lần gia hạn nào</td>
						</tr>
						<tr v-else v-for="(d,idx) in this.detail">
							<td scope="row">{{idx + 1}}</td>
							<td>{{ renderCreatedAt(d.created_at) }}</td>
							<td>{{d.life_time}}</td>
							<td>{{d.bonus}}</td>
							<td>{{ renderExpiresDate(d.expires_at) }}</td>
							<td>{{ formatPay(d.pay) }}</td>
							<td><a v-if="d.allow_delete" @click="deleteExtend" :rid="d.id" href="javascript:;">Xóa</a></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { Utilities } from "../../utilities";

	export default {

		data(){
			return {
				code: "",
				detail: [],
				expires: []
			}
		},

		methods: {
			fetchDetailSale: async function(){
				if(this.code === "") return;

				let res = await axios.get("admin-panel/report/sale_detail/" + this.code);
				res = res.data;

				if(res.code == 0){
					this.detail = res.data;
					this.expires = this.calcExpiresDate(res.data);
				}
			},

			deleteExtend: function(e){
				let vm = this;
				let currentTarget = e.currentTarget;
				let rid = $(currentTarget).attr("rid");

				swal({
					title: 'Xóa gia hạn cho tài khoản '+this.code,
					text: "Bạn chắc chắn muốn xóa? Hành động này là không thể phục hồi.",
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!'
				}).then(async function(result) {
					if (result.value) {
						let res = await axios.delete("admin-panel/report/sale_detail/" + vm.code + "/"+rid);
						res = res.data;

						if(res.code == 0){
							vm.fetchDetailSale();
						}
					}
				});
			},

			renderCreatedAt: function(created_at){
				return moment(created_at, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YYYY');
			},

			formatPay: function(pay){
				return Utilities.currencyFormat(pay);
			},

			renderExpiresDate: function(expires_at){
				return moment(expires_at).format("DD/MM/YYYY");
			},

			calcExpiresDate: function(detail){
				let before = null;
				let arr = [];

				for(let i=0;i<detail.length;i++){
					let createdAt = moment(detail[i].created_at, "YYYY/MM/DD HH:mm:ss");
					let life = detail[i].life_time + detail[i].bonus;
					
					if(before == null){
						before = createdAt.add(life, 'M');
					}else{
						let expired = createdAt.diff(before, "s") > 0;
						before = expired ? createdAt.add(life, 'M') : before.add(life, 'M');
					}

					arr[i] = before.format('DD/MM/YYYY');
				}
	
				return arr;
			},

			renderCode: function(){
				let c = $('#report_sale_detail').attr("playerCode");
				return c ? c.toUpperCase() : "";
			}
		}
	}
</script>